import { defineMessages } from 'react-intl';

export const bitbucketWorkspaceSelectorMessages = defineMessages({
  label: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.label',
    defaultMessage: 'Bitbucket workspace',
    description: 'Label above the Bitbucket workspace picker',
  },
  placeholder: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.placeholder',
    defaultMessage: 'Select a Bitbucket workspace',
    description: 'Placeholder text inside the Bitbucket workspace picker',
  },
});
